import { useContext } from "react"
import { AppContext } from "../context/AppContext"
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";



function SelectDomain() {

    const { permissions, domains, setSelectedDomain, setDomainName } = useContext(AppContext)


    return (<>
        {
            permissions && permissions['Select ChatBot Domain'] &&

            <Dropdown id="customDropdown" className="me-2">
                <Dropdown.Toggle id="customDropdownToggle" title="Domains" className="btn-light">
                    <FontAwesomeIcon
                        icon={faGlobe}
                        className="earth-icon icon"
                        width={20}
                    />
                </Dropdown.Toggle>

                <Dropdown.Menu id="customDropdownMenu"
                    style={domains.length > 10 && { height: '500px', overflowY: "scroll" }}
                >

                    {domains?.map((item, index) => (
                        <Dropdown.Item
                            href=""
                            key={item?.id}
                            onClick={() => {
                                setSelectedDomain(item?.id)
                                setDomainName(item?.domain)
                            }}
                        >
                            {item?.domain}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        }
    </>)

}

export default SelectDomain